// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gold {
  /*   background-color: #efb810;
  border: 2px solid #efb810;
  box-shadow: 0 0 10px 2px #efb810; */
  border-radius: 12px;
  /* background-color: #efb810; */
  border: 2px solid #efb810;
  box-shadow: 0 0 72px -3px #efb810;
}

.silver {
  /*   background-color: silver;
  border: 2px solid #c0c0c0;
  box-shadow: 0 0 10px 2px #c0c0c0; */
  border-radius: 12px;
  /* background-color: silver; */
  border: 2px solid #c0c0c0;
  box-shadow: 0 0 72px -3px rgba(192, 192, 192, 0.6666666667);
}

.bronze {
  border-radius: 12px;
  /* background-color: #cd7f32; */
  border: 2px solid #cd7f32;
  box-shadow: 0 0 72px -3px rgba(205, 127, 50, 0.4);
}

.visited-miradors {
  color: #a2a2a2;
  margin-left: 15px;
  font-size: 14px;
}

.card-title-icon {
  font-size: 44px;
  color: #efb810;
}

.card-title-ranking {
  font-size: 18px;
  text-align: center;
  font-weight: 400;
}

.card-content-ranking {
  padding: 0px 10px;
}
.card-content-ranking .separator {
  text-align: center;
  font-size: 25px;
  color: #ccc;
}

.card-ranking {
  border-radius: 12px;
  margin: 20px;
}

ion-item {
  display: flex;
  align-items: center;
  background-color: transparent;
  --inner-padding-top: 12px;
  --inner-padding-bottom: 12px;
}
ion-item .item-inner {
  overflow: visible;
  padding: 12px 0;
}
ion-item img {
  border-radius: 12px;
}

ion-item::part(native) {
  background: transparent;
}
ion-item::part(native) .item-inner {
  overflow: visible;
  padding: 12px 0;
}

.item-inner {
  overflow: visible;
  padding: 12px 0;
}

/* .item-inner {
  overflow: visible;
  padding: 12px 0;
} */
.ranking-info {
  display: flex;
  align-items: center;
  margin: 0 10px 0px 15px;
}

.ranking-dot {
  width: 8px;
  height: 8px;
  background-color: #a2a2a2;
  border-radius: 50%;
  margin-right: 5px;
}

.ranking-position {
  font-size: 16px;
  margin: 10px;
}

.adventurer-info {
  display: flex;
  flex-direction: column;
}

.adventurer-name {
  font-weight: bold;
}

.avatar {
  margin-right: 10px;
  width: 50px;
  height: 50px;
  margin-left: 10px;
}

.adventurer-chip {
  margin-bottom: 5px;
  max-width: 170px;
}

.chip-user-name {
  margin-bottom: 10px;
}

.item-user {
  display: block;
  overflow: visible;
}

.user-name-label {
  font-size: 16px;
  margin-left: 15px;
}

.ranking-icon {
  width: 60px;
  height: 60px;
  margin-left: 10px;
  border-radius: 12px;
}

cdk-virtual-scroll-viewport {
  height: 100%;
  width: 100%;
}

:host ::ng-deep .cdk-virtual-scroll-content-wrapper {
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/app/components/posts/ranking-adventurers/ranking-adventurers.component.scss"],"names":[],"mappings":"AAAA;EACE;;qCAAA;EAIA,mBAAA;EACA,+BAAA;EACA,yBAAA;EACA,iCAAA;AAAF;;AAGA;EACE;;qCAAA;EAIA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,2DAAA;AADF;;AAIA;EACE,mBAAA;EACA,+BAAA;EACA,yBAAA;EACA,iDAAA;AADF;;AAIA;EACE,cAAA;EACA,iBAAA;EACA,eAAA;AADF;;AAIA;EACE,eAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AADF;;AAIA;EACE,iBAAA;AADF;AAEE;EACE,kBAAA;EACA,eAAA;EACA,WAAA;AAAJ;;AAIA;EACE,mBAAA;EACA,YAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,yBAAA;EACA,4BAAA;AADF;AAGE;EACE,iBAAA;EACA,eAAA;AADJ;AAIE;EACE,mBAAA;AAFJ;;AAMA;EACE,uBAAA;AAHF;AAKE;EACE,iBAAA;EACA,eAAA;AAHJ;;AAOA;EACE,iBAAA;EACA,eAAA;AAJF;;AAOA;;;GAAA;AAMA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AANF;;AASA;EACE,UAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AANF;;AASA;EACE,eAAA;EACA,YAAA;AANF;;AASA;EACE,aAAA;EACA,sBAAA;AANF;;AASA;EACE,iBAAA;AANF;;AASA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AANF;;AASA;EACE,kBAAA;EACA,gBAAA;AANF;;AASA;EACE,mBAAA;AANF;;AASA;EACE,cAAA;EACA,iBAAA;AANF;;AASA;EACE,eAAA;EACA,iBAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AANF;;AAWA;EACE,YAAA;EACA,WAAA;AARF;;AAWA;EACE,kBAAA;AARF","sourcesContent":[".gold {\r\n  /*   background-color: #efb810;\r\n  border: 2px solid #efb810;\r\n  box-shadow: 0 0 10px 2px #efb810; */\r\n\r\n  border-radius: 12px;\r\n  /* background-color: #efb810; */\r\n  border: 2px solid #efb810;\r\n  box-shadow: 0 0 72px -3px #efb810;\r\n}\r\n\r\n.silver {\r\n  /*   background-color: silver;\r\n  border: 2px solid #c0c0c0;\r\n  box-shadow: 0 0 10px 2px #c0c0c0; */\r\n\r\n  border-radius: 12px;\r\n  /* background-color: silver; */\r\n  border: 2px solid #c0c0c0;\r\n  box-shadow: 0 0 72px -3px #c0c0c0aa;\r\n}\r\n\r\n.bronze {\r\n  border-radius: 12px;\r\n  /* background-color: #cd7f32; */\r\n  border: 2px solid #cd7f32;\r\n  box-shadow: 0 0 72px -3px #cd7f3266;\r\n}\r\n\r\n.visited-miradors {\r\n  color: #a2a2a2;\r\n  margin-left: 15px;\r\n  font-size: 14px;\r\n}\r\n\r\n.card-title-icon {\r\n  font-size: 44px;\r\n  color: #efb810;\r\n}\r\n\r\n.card-title-ranking {\r\n  font-size: 18px;\r\n  text-align: center;\r\n  font-weight: 400;\r\n}\r\n\r\n.card-content-ranking {\r\n  padding: 0px 10px;\r\n  .separator {\r\n    text-align: center;\r\n    font-size: 25px;\r\n    color: #ccc;\r\n  }\r\n}\r\n\r\n.card-ranking {\r\n  border-radius: 12px;\r\n  margin: 20px;\r\n}\r\n\r\nion-item {\r\n  display: flex;\r\n  align-items: center;\r\n  background-color: transparent;\r\n  --inner-padding-top: 12px;\r\n  --inner-padding-bottom: 12px;\r\n\r\n  .item-inner {\r\n    overflow: visible;\r\n    padding: 12px 0;\r\n  }\r\n\r\n  img {\r\n    border-radius: 12px;\r\n  }\r\n}\r\n\r\nion-item::part(native) {\r\n  background: transparent;\r\n\r\n  .item-inner {\r\n    overflow: visible;\r\n    padding: 12px 0;\r\n  }\r\n}\r\n\r\n.item-inner {\r\n  overflow: visible;\r\n  padding: 12px 0;\r\n}\r\n\r\n/* .item-inner {\r\n  overflow: visible;\r\n  padding: 12px 0;\r\n} */\r\n\r\n\r\n.ranking-info {\r\n  display: flex;\r\n  align-items: center;\r\n  margin: 0 10px 0px 15px;\r\n}\r\n\r\n.ranking-dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  background-color: #a2a2a2;\r\n  border-radius: 50%;\r\n  margin-right: 5px;\r\n}\r\n\r\n.ranking-position {\r\n  font-size: 16px;\r\n  margin: 10px;\r\n}\r\n\r\n.adventurer-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.adventurer-name {\r\n  font-weight: bold;\r\n}\r\n\r\n.avatar {\r\n  margin-right: 10px;\r\n  width: 50px;\r\n  height: 50px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.adventurer-chip {\r\n  margin-bottom: 5px;\r\n  max-width: 170px;\r\n}\r\n\r\n.chip-user-name {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.item-user {\r\n  display: block;\r\n  overflow: visible;\r\n}\r\n\r\n.user-name-label {\r\n  font-size: 16px;\r\n  margin-left: 15px;\r\n}\r\n\r\n.ranking-icon {\r\n  width: 60px;\r\n  height: 60px;\r\n  margin-left: 10px;\r\n  border-radius: 12px;\r\n\r\n\r\n}\r\n\r\ncdk-virtual-scroll-viewport {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n:host ::ng-deep .cdk-virtual-scroll-content-wrapper {\r\n  position: relative;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
